const heroSliders = document?.querySelectorAll('.hero-section');
heroSliders?.forEach((item) => {
  const sliderEl = item?.querySelector('.keen-slider');
  const prevBtn = item?.querySelector('.arrow-left');
  const nextBtn = item?.querySelector('.arrow-right');
  const slider = new KeenSlider(sliderEl,{
    loop:true
  },
  [
    (slider) => {
      let timeout
      let mouseOver = false
      function clearNextTimeout() {
        clearTimeout(timeout)
      }
      function nextTimeout() {
        clearTimeout(timeout)
        if (mouseOver) return
        timeout = setTimeout(() => {
          slider.next()
        }, 2000)
      }
      slider.on("created", () => {
        slider.container.addEventListener("mouseover", () => {
          mouseOver = true
          clearNextTimeout()
        })
        slider.container.addEventListener("mouseout", () => {
          mouseOver = false
          nextTimeout()
        })
        nextTimeout()
      })
      slider.on("dragStarted", clearNextTimeout)
      slider.on("animationEnded", nextTimeout)
      slider.on("updated", nextTimeout)
    },
  ]);
  nextBtn?.addEventListener('click', function () {
    slider?.next();
  });
  prevBtn?.addEventListener('click', function () {
    slider?.prev();
  });
});
